import { isNotDefined } from '@sgme/fp';
import { isBefore } from 'date-fns';

import type { BlotterTradeEntry } from '@/store/blotter/api/types/BlotterTradeEntry.ts';
import { convertAccumulatorEntry } from '@/store/blotter/types/BlotterAccumulatorEntry.ts';
import { convertCashEntry } from '@/store/blotter/types/BlotterCashEntry.ts';
import { convertOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';
import type { BlotterEntriesMaps } from '@/store/blotter/types/index.ts';
import type { ISODateTime } from '@/types/date.ts';

export const convertTradesForFront = (trades: BlotterTradeEntry[]): Omit<BlotterEntriesMaps, 'Order'> => {
  const result: Omit<BlotterEntriesMaps, 'Order'> = { Cash: {}, Option: {}, Accumulator: {} };

  for (const webapiEntry of trades) {
    switch (webapiEntry.blotterType) {
      case 'Cash': {
        upsertEntry(convertCashEntry(webapiEntry), result.Cash);
        break;
      }
      case 'Option': {
        upsertEntry(convertOptionEntry(webapiEntry), result.Option);
        break;
      }
      case 'Accumulator': {
        upsertEntry(convertAccumulatorEntry(webapiEntry), result.Accumulator);
        break;
      }
      default: {
        console.warn(`Unknown trade entry type ${webapiEntry.blotterType}`);
        break;
      }
    }
  }

  return result;
};

export interface Upsertable {
  id: string;
  updateTime: ISODateTime;
}

export function upsertEntry<T extends Upsertable>(entry: T | null, map: Record<string, T>): void {
  if (isNotDefined(entry)) {
    return;
  }
  const existing = map[entry.id];
  if (isNotDefined(existing) || isBefore(existing.updateTime, entry.updateTime)) {
    map[entry.id] = entry;
  }
}
